import styled from "styled-components";
import "@nectary/components/spinner";

export const LoadingScreenContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const LoadingScreen = () => (
  <LoadingScreenContainer>
    <sinch-spinner size="l" />
  </LoadingScreenContainer>
);

// eslint-disable-next-line no-restricted-syntax
export default LoadingScreen;
